import { GameElement } from "./gameElementTypes";

export const Debug = {
	/**Set to any value greater than 0 to turn on deterministic rng */
	DeterministicSeed: 0,

	CaptureMode: false,

	KeepTraceLogs: false,
	ShowHitboxes: false,
	ShowTargetingRange: false,
	ShowTargetLine: true,
	ShowFPS: false,

	MinimalCrap: false,
	ManualSimulationStart: false,
	DemoSkip: true,

	SkipRecap: false,
	SkipTutorial: false,

	NoInfectedCells: false,
	StartingInfectedCells: 0,
	StartingInfectedCellsType: GameElement.VIRUS,
	ForceVirusType: new Array<GameElement>(),
	ForceImmuneCell: new Array<GameElement>(),
	ForceLaneAngles: new Array<number>(),
	ForceLaneDistances: new Array<number>(),
	ForceWaveLanes: new Array<number>(),
	ForceBattleRounds: new Array<number>(),

	AllowGameWithOnlyBots: false,

	AllowVirusInShop: false,

	KeepInspection: false,

	ForcePlayerId: -1,
	ForceNumberOfPlayers: 0,

	ColorPaletteVialUrlAllowed: false,

	EnableAudioMixer: false,

	EnableAnalytics: true,
	DebugAnalytics: false,

	OverrideFunds: -1,

	PlayAgainstLastReplay: false,
	DontReportReplay: false,
	SaveReplayEveryTurn: false,
	UseLocalJoinUrl: false,

	UseDevReplays: false,

	SystemPerformanceTracking: false,

	NoEAPopup: false,

	NoAchievements: false,
}
